/**
 * Import i18n, the international standard to manage locale.
 * We just need import this in any js modules that require language config.
 */
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import axios from 'axios';
//import zh from '../../../../public/locale/zh';


const messages = {
    //'zh': zh
};


// our default language that is preloaded
//const loadedLanguages = ['zh']
const loadedLanguages = [];

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: loadedLanguages,
    //fallbackLocale: 'zh',
    messages
});

function setI18nLocale(lang){
    i18n.locale = lang
    axios.defaults.headers.common['Accept-Language'] = lang;
    document.querySelector('html').setAttribute('lang', lang);
    return lang;
}

export function changeLocale (lang) {
    if (i18n.locale !== lang) {
        if (!loadedLanguages.includes(lang)) {
            return import(
                    /* webpackChunkName: "locale-[request]" */
                    /* webpackInclude: /\.json$/ */
                    //`../../js/i18n/${lang}`
                    `../../../../public/locale/${lang}`
            ).then(msgs => {
                i18n.setLocaleMessage(lang, msgs);
                messages.zh = msgs;
                loadedLanguages.push(lang);
                return setI18nLocale(lang);
            })
        }
        return Promise.resolve(setI18nLocale(lang));
    }
    return Promise.resolve(lang);
}

export default i18n;




// WEBPACK FOOTER //
// ./resources/assets/js/i18n/index.js